<template>
    <div class="user-mini" :class="{'added': hasUser}" @click="addUser()">
        <div class="user-mini__check">
            <img src="@/assets/images/icon_check-user.svg">
        </div>
        <div class="user-mini__avatar" :style="{backgroundImage: 'url(' + getAvatar(user) + ')'}"></div>
        <div class="user-mini-info">
            <h6>{{ user.firstname + ' ' + user.lastname}}</h6>
            <div class="user-mini-categories" v-if="user.sports">
                <span :class="sport.color" v-for="sport in shortSports(user)" :key="sport.id">{{ sport.ru }}</span>
                <span :style="{'backgroundColor': 'gray'}" v-if="user.sports.length > 5">и еще {{user.sports.length - 5}}</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'UserMini',
    props: {
        user: {
            type: Object,
            require: true
        },
        added: {
            type: Array,
            require: false,
        }
    },
    computed: {
        hasUser () {
            return this.added.find(item => item === this.user.id) ? true : false
        },
    },
    methods: {
        shortSports(user) {
            return user.sports.slice(0, 5)
        },
        addUser () {
            !this.hasUser ? this.added.push(this.user.id) : this.added.splice(this.added.indexOf(this.user.id), 1);
        },
        getAvatar(user) {
            return user.deleted ? require('@/assets/images/defaults/dead.svg') : user.avatar
        },
    }
}
</script>
<style lang="stylus">
.user-mini
    display flex
    align-items center
    background-color #F0F0F0
    border-radius 20px
    margin 6px 0
    padding 20px
    position relative
    cursor pointer

    &.added
        .user-mini__check
            opacity 1
            pointer-events all
    
    &__check
        width 20px
        height 20px
        border-radius 50%
        position absolute
        background-color #8fbc8f
        right 10px
        top 10px
        pointer-events none
        opacity 0
        display flex
        align-content center
        justify-content center
        img
            max-width 60%

    &__avatar
        width 50px
        height 50px
        border-radius 50%
        background-color #4F4F4F
        margin-right 20px
        background-size cover
        background-position center
    
    &-info
        h6
            font-size 12px
            color #2E3A59
            font-weight 500
            padding-bottom 8px

    &-categories
        display flex
        align-items center
        span
            color transparent
            text-transform lowercase
            max-width 16px
            height 16px
            border-radius 16px
            padding 3px 8px
            margin-right 3px
            font-weight 500
            overflow hidden
            t()
            &:hover
                max-width 1000px
                color white
</style>